<template>
  <article class="call__screen">
    <section class="call__screen-row">
      <span class="icon">{{ firstInitial }}</span>
      <span>{{ name }}</span>
    </section>
    <section>
      <h1>{{ phoneNumber }}</h1>
    </section>
    <div>
      <ul class="call__screen-numpad">
        <li @click="addNum('1')">1</li>
        <li @click="addNum('2')">2</li>
        <li @click="addNum('3')">3</li>
        <li @click="addNum('4')">4</li>
        <li @click="addNum('5')">5</li>
        <li @click="addNum('6')">6</li>
        <li @click="addNum('7')">7</li>
        <li @click="addNum('8')">8</li>
        <li @click="addNum('9')">9</li>
        <li @click="addNum('*')">*</li>
        <li @click="addNum('0')">0</li>
        <li @click="addNum('#')">#</li>
        <li>
          <img
            class="bubble"
            src="../assets/icons/call/bubble.png"
            alt="bubble"
          />
        </li>
        <li>
          <div class="call-button" @click="navHome">
            <img
              src="../assets/icons/pindetail/phone-flip.png"
              alt="call icon"
            />
          </div>
        </li>
        <li>
          <img
            class="clear"
            src="../assets/icons/call/clear-symbol.png"
            alt="clear"
          />
        </li>
      </ul>
    </div>
  </article>
</template>

<script>
export default {
  name: "Call",
  props: {},
  data() {
    return {
      name: this.$route.params.name,
      num: "",
    }
  },
  methods: {
    addNum(newNumber) {
      this.num += newNumber
    },
    navHome() {
      this.$router.push("/home")
    },
  },
  computed: {
    firstInitial() {
      return this.name.slice(0, 1)
    },
    phoneNumber() {
      if (this.$route.params.name === "Sam Morris") {
        return "(313) 928-0198"
      } else return "313-972-1256"
    },
  },
}
</script>

<style lang="scss" scoped>
.call__screen {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-self: center;
  width: 100%;
  height: 100%;
  padding-top: 10%;

  @media only screen and (min-height: 900px) {
    font-size: 2rem;
  }

  h1 {
    font-size: 1.75rem;
    font-weight: normal;
    margin-top: 10%;
    margin-bottom: 0.25rem;

    @media only screen and (min-height: 900px) {
      font-size: 2.75rem;
    }
  }

  .icon {
    color: #ffffff;
    border-radius: 50%;
    background-color: #2c72ff;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5%;

    @media only screen and (min-height: 900px) {
      width: 60px;
      height: 60px;
    }
  }

  .small-num {
    color: grey;
    margin-left: 5%;
  }

  &-row {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10%;
  }

  &-numpad {
    font-size: 2.75rem;
    list-style: none;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: 27%;
    padding: 5px;
    margin-top: 15%;
    height: 30vh;
    margin-left: 9%;
    width: 80%;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    @media only screen and (max-height: 900px) {
      height: 30vh;
      margin-top: 10%;
      font-size: 1.75rem;
    }

    img {
      width: 60px;
      height: 60px;
      padding-top: 2px;
    }

    @media only screen and (max-height: 900px) {
      img {
        height: 30px;
        width: 30px;
      }
    }

    .bubble,
    .clear {
      padding-top: 4px;
    }
  }

  .call-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #21c97a;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    font-size: 0.8rem;
    color: #fff;
    margin: 0 auto;

    img {
      height: 60px;
      width: 60px;
      border-radius: 50%;
    }

    @media only screen and (max-height: 900px) {
      width: 45px;
      height: 45px;

      img {
        height: 30px;
        width: 30px;
      }
    }
  }

  .call-button:hover {
    cursor: pointer;
  }
}
</style>
